import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="max-w-lg mx-auto px-5 py-24 text-center paper-noise min-h-[70vh]">
      <XCircle className="w-14 h-14 text-[#8C857B] mx-auto mb-6" />
      <h1 className="font-serif text-4xl tracking-tight text-[#2C2A28]">{t("payment.cancelTitle")}</h1>
      <p className="text-[#5C5854] mt-3">{t("payment.cancelDesc")}</p>
      <Button onClick={() => navigate("/tarifs")} className="rounded-full mt-8 bg-[#E06D53] hover:bg-[#C95B42] text-white" data-testid="cancel-retry">{t("payment.cancelRetry")}</Button>
    </div>
  );
}
